{
  "nav": {
    "login": "Войти"
  },
  "hero": {
    "badge": "Учёт посещаемости по лицу или отпечатку пальца",
    "title": "Посещаемость и зарплата сотрудников — на автопилоте",
    "subtitle": "Терминал с распознаванием лица и отпечатка пальца на входе, приходы и уходы в реальном времени, табель, отпуска и зарплатные отчёты — всё в одной платформе.",
    "cta": "Заказать демо",
    "ctaSecondary": "Войти",
    "mock": {
      "title": "Сегодня",
      "checkedIn": "Пришёл",
      "late": "Опоздание",
      "onVacation": "Отпуск"
    }
  },
  "features": {
    "title": "Всё для управления командой",
    "subtitle": "От первого взгляда в терминал до итоговой суммы зарплаты — без таблиц и ручного подсчёта.",
    "items": {
      "terminal": {
        "title": "Распознавание лица/отпечатка",
        "text": "Сотрудник отмечается взглядом или отпечатком пальца — без карт и очередей."
      },
      "live": {
        "title": "Приходы и уходы в реальном времени",
        "text": "Каждый вход и выход мгновенно появляется в платформе. Опоздания видны сразу."
      },
      "reports": {
        "title": "Табель и зарплата",
        "text": "Таблица посещаемости, удержания за опоздания, сверхурочные, авансы и итоговая зарплата — считаются автоматически."
      },
      "timeoff": {
        "title": "Отпуска и отсутствия",
        "text": "Отпуска, больничные и командировки планируются заранее и учитываются в каждом расчёте."
      },
      "notifications": {
        "title": "Уведомления в Telegram",
        "text": "Оповещения о приходах и опозданиях — прямо в вашу группу в Telegram."
      },
      "languages": {
        "title": "Три языка",
        "text": "Весь интерфейс доступен на армянском, русском и английском."
      }
    }
  },
  "how": {
    "title": "Как это работает",
    "steps": {
      "one": {
        "title": "Устанавливаем терминал",
        "text": "Терминал с распознаванием лица и отпечатка пальца монтируется на входе и подключается к платформе за считанные минуты."
      },
      "two": {
        "title": "Сотрудники отмечаются взглядом или отпечатком",
        "text": "Каждый вход и выход распознаётся и записывается автоматически — без карт и бумажных журналов."
      },
      "three": {
        "title": "Вы получаете цифры",
        "text": "Дашборды, табели и зарплатные отчёты всегда актуальны и готовы к выгрузке."
      }
    }
  },
  "book": {
    "title": "Заказать демо",
    "subtitle": "Оставьте контакты — мы свяжемся с вами и покажем платформу в действии.",
    "form": {
      "name": "Ваше имя",
      "namePlaceholder": "Имя Фамилия",
      "phone": "Телефон",
      "phonePlaceholder": "+374 ...",
      "submit": "Отправить заявку",
      "sending": "Отправка…",
      "required": "Пожалуйста, укажите имя и номер телефона.",
      "success": "Спасибо! Заявка получена — мы скоро свяжемся с вами.",
      "successAnother": "Отправить ещё одну заявку",
      "error": "Не удалось отправить заявку. Попробуйте ещё раз или свяжитесь с нами напрямую."
    },
    "contactTitle": "Или свяжитесь с нами напрямую",
    "emailLabel": "Email",
    "phoneLabel": "Телефон"
  },
  "footer": {
    "rights": "Все права защищены."
  },
  "seo": {
    "title": "Платформа управления сотрудниками — посещаемость, табель, зарплата",
    "description": "Терминал с распознаванием лица/отпечатка, приходы и уходы в реальном времени, табель, отпуска, расчёт зарплаты и Telegram-уведомления — всё в одной платформе. Закажите демо."
  }
}
